<template>
  <div class="action-blocks">
    <ActionBlock
      v-for="(block, index) in customBlocks"
      :key="index"
      :title="block.title"
      :description="block.description"
      :icon="block.icon"
      :icon-src="block.iconSrc"
      :action="block.action"
      :plain="plain"
      :rewards="rewards"
    />
  </div>
</template>

<script>
import ActionBlock from "./ActionBlock.vue";

export default {
  name: "ActionBlocks",
  components: {
    ActionBlock,
  },
  props: {
    customBlocks: {
      type: Array,
      default: () => [],
    },
    plain: {
      type: Boolean,
      default: false,
    },
    rewards: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.action-blocks {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;

  @include respond-above(md) {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
